class CareerSlider {
  constructor(el) {
    this.root = document.querySelector('.' + el);
    if (!this.root || typeof Swiper === 'undefined') return;

    this.slides = this.root.querySelectorAll('.swiper-slide');
    if (this.slides.length < 2) return;

    this.pagination = document.querySelector('.js-career-pagination');
    this.reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    this.spQuery = window.matchMedia('(max-width: 767px)');
    this.swiper = null;
    this.scrollHint = null;
    this.onDismissHint = () => this.dismissScrollHint();

    this.spQuery.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    if (this.spQuery.matches) {
      this.init();
    } else {
      this.destroy();
    }
  }

  init() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.root, {
      slidesPerView: 1,
      spaceBetween: '7%',
      speed: this.reduceMotion ? 0 : 600,
      // STEP番号を CSS カウンタで出しているので loop（スライド複製）は使わない
      threshold: 8,
      preventClicks: true,
      preventClicksPropagation: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: this.pagination,
        clickable: true,
        bulletClass: 'p-training__career-pagination-bullet',
        bulletActiveClass: 'is-active',
      },
      a11y: {
        enabled: true,
        slideRole: null,
        paginationBulletMessage: '{{index}}番目のステップへ',
      },
    });

    this.initScrollHint();
  }

  initScrollHint() {
    if (this.scrollHint || typeof ScrollHint === 'undefined') return;

    // Swiper は transform で動くため scrollWidth 判定が偽陰性になる。
    // offset を負にしてヒント表示条件だけ通し、overflow は直後に戻す。
    this.scrollHint = new ScrollHint(this.root, {
      enableOverflowScrolling: false,
      offset: -1,
      i18n: {
        scrollable: 'スクロールできます',
      },
    });

    this.root.style.overflow = 'hidden';

    this.swiper.on('touchStart', this.onDismissHint);
    this.swiper.on('slideChange', this.onDismissHint);
    if (this.pagination) {
      this.pagination.addEventListener('click', this.onDismissHint);
    }
  }

  dismissScrollHint() {
    if (!this.scrollHint || !this.scrollHint.items) return;

    this.scrollHint.items.forEach((item) => {
      item.interacted = true;
      this.scrollHint.updateItem(item);
    });
  }

  destroyScrollHint() {
    if (!this.scrollHint) return;

    if (this.swiper) {
      this.swiper.off('touchStart', this.onDismissHint);
      this.swiper.off('slideChange', this.onDismissHint);
    }
    if (this.pagination) {
      this.pagination.removeEventListener('click', this.onDismissHint);
    }

    const icon = this.root.querySelector('[data-target="scrollable-icon"]');
    if (icon) icon.remove();

    this.root.classList.remove(
      'scroll-hint',
      'is-scrollable',
      'is-right-scrollable',
      'is-left-scrollable'
    );
    this.root.style.position = '';
    this.root.style.overflow = '';
    this.scrollHint = null;
  }

  destroy() {
    this.destroyScrollHint();

    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}
